import { getCookie } from "$javascript/cookies.js"

function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const secure = location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax${secure}`;
}

const params = new URLSearchParams(window.location.search);
const refParam = params.get('ref');

if (refParam && !getCookie('ref')) {
  setCookie('ref', refParam, 30);
}

